import { Box } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { getFormattedCurrency } from '../../../utils/business/prices';
import { ROUNDED_ELEMENT_PROPS, SMALLBOX_PROPS } from '../../../utils/styleUtil';
import LabelWithText from '../../generic/LabelWithText';

const ProductPrice = ({ price, priceWithoutPromo, isFree }) => {
  const actualPriceWithoutPromo = priceWithoutPromo != null && !isFree ? parseFloat(priceWithoutPromo) : null;
  const actualPrice = price != null && !isFree ? parseFloat(price) : null;
  const hasPromo = actualPriceWithoutPromo != null && actualPriceWithoutPromo > actualPrice;

  return (
    <Box bg="brand.background_smallbox" flexShrink={0} {...ROUNDED_ELEMENT_PROPS} minWidth="160px" {...SMALLBOX_PROPS}>
      <LabelWithText label={<Trans>From</Trans>} text={isFree ? <Trans>Free</Trans> : getFormattedCurrency(price)} textSize="md" />
      {hasPromo && (
        <LabelWithText label={getFormattedCurrency(priceWithoutPromo)} strikeLabel labelSize="sm" labelColor="brand.color_alert_error_icon" />
      )}
    </Box>
  );
};

export default ProductPrice;
